import { render, staticRenderFns } from "./WelcomeV2.vue?vue&type=template&id=3e8fd8c6&scoped=true"
import script from "./WelcomeV2.vue?vue&type=script&lang=js"
export * from "./WelcomeV2.vue?vue&type=script&lang=js"
import style0 from "./WelcomeV2.vue?vue&type=style&index=0&id=3e8fd8c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8fd8c6",
  null
  
)

export default component.exports